import { useTokenStore } from 'Shared/hooks/useTokenStore';
import { QUERY_KEY } from '@constants';
import type { GetNotificationListResponse } from 'viewup-api/v2';
import type { QueryParam } from 'viewup-lib/common';
import { useSDQuery } from 'viewup-lib/react';
import { type GetNotificationReq, getNotification } from './mapper';

export const useGetNotification = (
  query?: GetNotificationReq,
  params?: QueryParam<GetNotificationListResponse>,
) => {
  const { accessToken } = useTokenStore();

  return useSDQuery<GetNotificationListResponse>({
    ...params?.options,
    queryFn: () => getNotification(query),
    queryKey: [QUERY_KEY.NOTIFICATIONS, query],
    enabled: !!accessToken,
  });
};
